// libraries.
import { useSelector } from 'react-redux';

// slices.
import { RolesGuard } from '@domains/user';
import { UserRoles } from '@domains/user/utils/roles';
import { getIsHoveredSidebar } from '@shared/Sidebar/store/slices/sidebar-slice';
import {
  getIsDocumentReviewerRole,
  getIsRoleIsPolygonCreator,
  getRole,
} from '@domains/user/store/slices/user-slice/user-slice';

// components.
import { ButtonLogo, Sidebar } from '@shared';
import { ButtonToolPolygon } from './components/ButtonToolPolygon';
import { DropdownCountry } from '@domains/user/components/DropdownCountry/DropdownCountry';
import { LogOutButton } from '@domains/user/components/LogOutButton/LogOutButton';
import { ButtonOrchestrator } from './components/ButtonOrchestrator';
import { ButtonPolygonViewer } from './components/ButtonPolygonViewer';
import { ButtonDocumentsTool } from './components/ButtonDocumentsTool';

export const SidebarHome = () => {
  const isHoveredSidebar = useSelector(getIsHoveredSidebar);
  const agentIsPolygonCreator = useSelector(getIsRoleIsPolygonCreator);
  const isDocumentReviewer = useSelector(getIsDocumentReviewerRole);
  const userRoles = useSelector(getRole);
  const isLeader = userRoles?.includes(UserRoles.IDM_LEAD);

  return (
    <Sidebar
      upperButtons={
        <>
          <ButtonLogo />
          {agentIsPolygonCreator && <ButtonToolPolygon />}
          {!agentIsPolygonCreator && <ButtonPolygonViewer />}
          {(isDocumentReviewer || isLeader) && <ButtonDocumentsTool />}
          <RolesGuard roles={[UserRoles.IDM_LEAD]}>
            <ButtonOrchestrator />
          </RolesGuard>
        </>
      }
      lowerButtons={
        <>
          <DropdownCountry isHoveredSidebar={isHoveredSidebar} />
          <LogOutButton />
        </>
      }
    />
  );
};
